import { render, staticRenderFns } from "./CardTable.vue?vue&type=template&id=48c40ad7&scoped=true"
import script from "./CardTable.vue?vue&type=script&lang=js"
export * from "./CardTable.vue?vue&type=script&lang=js"
import style0 from "./CardTable.vue?vue&type=style&index=0&id=48c40ad7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c40ad7",
  null
  
)

export default component.exports